import script from "./modelrunner.vue?vue&type=script&setup=true&lang=js"
export * from "./modelrunner.vue?vue&type=script&setup=true&lang=js"

import "./modelrunner.vue?vue&type=style&index=0&id=29d232ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29d232ac"]])

export default __exports__